import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-p-2" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BatchClassForm = _resolveComponent("BatchClassForm")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BlockUI, { blocked: _ctx.loading }, {
      default: _withCtx(() => [
        _createVNode(_component_BatchClassForm, {
          batchClass: _ctx.batchClass,
          showErrorMessage: _ctx.showErrorMessage,
          llmActive: _ctx.llmActive,
          "onUpdate:llmActive": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.llmActive) = $event)),
          onUpdate: _ctx.onUpdate
        }, null, 8, ["batchClass", "showErrorMessage", "llmActive", "onUpdate"])
      ]),
      _: 1
    }, 8, ["blocked"]),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "p-offset-9" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          disabled: _ctx.loading,
          label: _ctx.saveButtonText,
          type: "button",
          icon: "mdi mdi-content-save-outline",
          class: "p-button",
          onClick: _ctx.saveBatchClass
        }, null, 8, ["disabled", "label", "onClick"])
      ])
    ])
  ]))
}